import { useEffect } from "react";
import BloqueioCadastroNotice from "../BloqueioCadastroNotice";
import { Container, ErrorBox, ErrorList, InnerErrorList } from "./styles";

export interface PaymentErrorData {
  error?: string | null;
  returnMessage?: string | null;
}

export interface ItemError {
  codigoErro: number;
  mensagem: string;
  mercadoria: number;
  pedido: number;
}

export interface OrderErrorState {
  genericError?: string;
  itemErrors?: ItemError[];
  paymentError?: PaymentErrorData;
}

export interface ValidationMessage {
  id: string;
  message: string;
}

interface OrderErrorProps {
  paymentMethod?: "parcelamento" | "cartao";
  orderError?: OrderErrorState | null;
  validationMessages?: ValidationMessage[];
  showBloqueioCadastroNotice?: boolean;
}

const OrderError = ({
  paymentMethod,
  orderError,
  validationMessages,
  showBloqueioCadastroNotice = false,
}: OrderErrorProps) => {
  const paymentError = orderError?.paymentError;
  const genericError = orderError?.genericError;
  const itemErrors = orderError?.itemErrors;

  const hasPaymentError =
    paymentMethod === "cartao" &&
    Boolean(paymentError?.error || paymentError?.returnMessage);

  const hasGenericError = Boolean(genericError);
  const hasItemErrors = Boolean(itemErrors && itemErrors.length > 0);
  const hasFinalizationError = hasGenericError || hasItemErrors;
  const hasValidation = Boolean(
    validationMessages && validationMessages.length > 0
  );

  useEffect(() => {
    if (hasPaymentError || hasFinalizationError) {
      window.scrollTo({ top: 300, behavior: "smooth" });
    }
  }, [hasPaymentError, hasFinalizationError]);

  if (
    !hasPaymentError &&
    !hasFinalizationError &&
    !hasValidation &&
    !showBloqueioCadastroNotice
  ) {
    return null;
  }

  return (
    <>
      {hasPaymentError && paymentError && (
        <Container id="paymentError">
          <ErrorBox>
            <p>Seu pedido não pode ser finalizado</p>
            <p>
              <strong>Mensagem do cartão:</strong>{" "}
              {paymentError.error ||
                "Erro ao efetuar pagamento! Entre em contato com a operadora do cartão."}
            </p>
            {paymentError.returnMessage && (
              <p>
                Motivo: <strong>{paymentError.returnMessage}</strong>
              </p>
            )}
            <p>Verifique os dados do cartão e tente novamente.</p>
          </ErrorBox>
        </Container>
      )}

      {hasFinalizationError && (
        <Container id="orderError">
          <ErrorBox>
            <p>Seu pedido não pode ser finalizado</p>

            {hasGenericError && (
              <p>
                <strong>Erro:</strong> {genericError}
              </p>
            )}

            {hasItemErrors && (
              <>
                <p>
                  <strong>
                    {hasGenericError
                      ? "Itens com problema:"
                      : "Os seguintes itens não puderam ser processados:"}
                  </strong>
                </p>
                <InnerErrorList>
                  {itemErrors!.map(item => (
                    <li key={item.mercadoria}>
                      Mercadoria {item.mercadoria}: {item.mensagem}
                    </li>
                  ))}
                </InnerErrorList>
              </>
            )}

            <p>Tente novamente mais tarde.</p>
          </ErrorBox>
        </Container>
      )}

      {hasValidation && (
        <Container id="validationError">
          <ErrorList>
            {validationMessages!.map(({ id, message }) => (
              <li key={id}>{message}</li>
            ))}
          </ErrorList>
        </Container>
      )}

      {showBloqueioCadastroNotice && <BloqueioCadastroNotice />}
    </>
  );
};

export default OrderError;
